import { createContext, Dispatch } from "react";
import {
  DEFAULT_VISITOR_CONTEXT,
  TVisitorContext,
} from "src/trackers/viewerContext";

import { PublicationShortname } from "./auth/serviceIdentifier";
import { TAction } from "./reducer";

export type TAppContext = {
  pubId: PublicationShortname;
  issueId?: number;
  visitorContext: TVisitorContext | null;
  dispatch: Dispatch<TAction>;
};

const defaultInitialState: TAppContext = {
  pubId: PublicationShortname.DEFAULT,
  issueId: undefined,
  visitorContext: DEFAULT_VISITOR_CONTEXT,
  dispatch: () => null,
};

export function getInitialState(): TAppContext {
  return defaultInitialState;
}

const AppContext = createContext<TAppContext>(getInitialState());

export default AppContext;
